export default {
	initTransaction(params) {
		return window.Vue.$http.post('transaction/init', params)
	},
	serviceCharge(params) {
		return window.Vue.$http.post('transaction/servicecharge', params)
	},
	post(params) {
		return window.Vue.$http.post('transaction/createweb', params)
	},
	limitCheck(params) {
		return window.Vue.$http.post('transaction/validation/limit', params)
	},
	validateAlipay(params) {
		return window.Vue.$http.post('v2/transaction/validate/alipay', params)
	},
	validateBkashWallet(params) {
		return window.Vue.$http.post('v2/transaction/validate/bkash', params)
	},
	validateWeixinWallet(params) {
		return window.Vue.$http.post('v2/transaction/validate/weixinwalletnumber', params)
	},
	validateUnionPay(params) {
		return window.Vue.$http.post('v2/transaction/validate/unionpay', params)
	},
	reprocess(params) {
		return window.Vue.$http.post('transaction/reprocess', params)
	},
	visaCardInquiry(params) {
		return window.Vue.$http.post('transaction/visadirect/cardinquiry', params)
	},
	saveVisaBeneOnCurrencyMismatch(params) {
		return window.Vue.$http.post('transaction/visadirect/update/beneficiaryoncurrencymismatch', params)
	},

	getDetail(refno) {
		return window.Vue.$http.get("transaction/detail/" + refno)
	},
	getDetailDuringReprocess(refno, onbehalfId) {
		return window.Vue.$http.get('v2/transaction/detail/reprocess/' + refno + '/' + onbehalfId);
	},
	getConfirmation(refno) {
		return window.Vue.$http.get("transaction/confirmation/" + refno)
	},
	getConfirmationBC(refno) {
		return window.Vue.$http.get("transaction/confirmationbc/" + refno)
	},
	getSummary(refno) {
		return window.Vue.$http.get("transaction/summary/" + refno)
	},
	getPaymentMode(val) {
		switch (val) {
			case 2:
				return "Cash Pickup";
			case 21:
				return "Union Pay Card";
			case 22:
				return "Alipay";
			case 23:
				return "bKash";
			case 24:
				return "eWallet";
			case 99:
				return "Moneygram";
			case 97:
				return "Cash Pickup";
			case 98:
				return "Bank Account";
			case 101:
				return "Visa Debit Card";
			case 102:
				return "Bank Account";
			case 25:
				return "Wing Wallet";
			case 27:
				return "Weixin Wallet";
			case 28:
				return "eWallet";
			case 29:
				return "eWallet";
			case 30:
				return "Nagad Wallet";
			default:
				return "Bank Account";
		}
	},
	getSpecialRateDetail(params) {
		return window.Vue.$http.post("v2/transaction/specialRate/", params)
	},
}
